import { STALE_TIME } from "#app/http/ReactQueryProvider";
import {
  CompanyMachineDto,
  fetchCompanyMachines,
} from "#modules/machines/infra/fetchCompanyMachines.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";
import { QueryOptions } from "#types/QueryOptions";

export const companyMachinesQuery = (): QueryOptions<CompanyMachineDto[] | null> => ({
  queryKey: queryKeys.companyMachines.all,
  queryFn: fetchCompanyMachines,
  staleTime: STALE_TIME,
});
